/**
 * Mock Alerts Data
 *
 * Demo/test alerts for development and demonstration purposes.
 * Used by alertSlice.initializeMockAlerts reducer.
 */

import { MockAlert } from '@/types/alerts'

export const MOCK_ALERTS: MockAlert[] = [
  {
    message: 'Classic Latte sales dropped 8% compared to last week.',
    hierarchy: {
      clarityLens: 'Lattes',
      category: 'Classic - The original',
      tab: 'Overview',
    },
  },
  {
    message: 'Classic Latte sales dropped 8% compared to last week.',
    hierarchy: {
      clarityLens: 'Lattes',
      category: 'Classic - The original',
      tab: 'Overview',
    },
  },
  {
    message:
      'Revenue from Classic Latte decreased by $1,500 vs previous period.',
    hierarchy: {
      clarityLens: 'Lattes',
      category: 'Classic - The original',
      tab: 'Sales',
    },
  },
  {
    message: 'Latte + Cookie bundle down 18% compared to last month.',
    hierarchy: {
      clarityLens: 'Lattes',
      category: 'Classic - The original',
      tab: 'Bought Together',
    },
  },
  {
    message: 'Latte + Cookie bundle down 18% compared to last month.',
    hierarchy: {
      clarityLens: 'Lattes',
      category: 'Classic - The original',
      tab: 'Bought Together',
    },
  },
  {
    message: 'Aloha sales dropped 8% compared to last week.',
    hierarchy: {
      clarityLens: 'Lattes',
      category: 'Aloha - Chocolate Macadamia',
      tab: 'Overview',
    },
  },
  {
    message: 'Irish Dream sales dropped 8% compared to last week.',
    hierarchy: {
      clarityLens: 'Lattes',
      category: 'Irish Dream - Irish Cream',
      tab: 'Overview',
    },
  },
  {
    message: 'Caramel Macchiato sales dropped 8% compared to last week.',
    hierarchy: {
      clarityLens: 'Lattes',
      category: 'Caramel Macchiato',
      tab: 'Overview',
    },
  },
]

